var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkFromHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D9E2FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15L16 6L25 15",
    stroke: "#5569A0",
    strokeWidth: 1.6083,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3892 15.0396C13.3893 14.6085 13.5172 14.1871 13.7568 13.8287C13.9964 13.4703 14.3369 13.191 14.7352 13.0261C15.1335 12.8612 15.5718 12.8181 15.9946 12.9023C16.4174 12.9865 16.8057 13.1941 17.1105 13.499C17.4153 13.8039 17.6229 14.1923 17.7069 14.6151C17.791 15.0379 17.7478 15.4762 17.5828 15.8745C17.4178 16.2727 17.1384 16.6131 16.7799 16.8526C16.4215 17.0921 16.0001 17.22 15.569 17.22C15.2827 17.22 14.9992 17.1636 14.7347 17.054C14.4702 16.9444 14.2298 16.7838 14.0274 16.5813C13.825 16.3788 13.6644 16.1385 13.5549 15.8739C13.4454 15.6094 13.3891 15.3259 13.3892 15.0396Z",
    fill: "#5569A0",
    stroke: "#5569A0",
    strokeWidth: 0.169261
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9161 18.1917H18.2594C18.5024 18.1917 18.7354 18.2882 18.9072 18.46C19.079 18.6318 19.1755 18.8648 19.1755 19.1078V23.5543C19.1755 23.7972 19.079 24.0303 18.9072 24.2021C18.7354 24.3739 18.5024 24.4704 18.2594 24.4704H12.9161C12.6731 24.4704 12.4401 24.3739 12.2683 24.2021C12.0965 24.0303 12 23.7972 12 23.5543V19.1078C12 18.8648 12.0965 18.6318 12.2683 18.46C12.4401 18.2882 12.6731 18.1917 12.9161 18.1917V18.1917Z",
    fill: "#5569A0",
    stroke: "#5569A0",
    strokeWidth: 0.169261
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkFromHome);
export default __webpack_public_path__ + "static/media/WorkFromHome.841b37b41f7ac8e8f5b8983b8e1aeb34.svg";
export { ForwardRef as ReactComponent };